/**
 * Show the confirm-name screen only after the Firestore user doc attempt finished,
 * and only if this account has not already finished onboarding.
 */
export function shouldPromptDisplayNameOnboarding(opts: {
  userDocReady: boolean;
  displayNameOnboardingDone?: boolean;
  cachedDone: boolean;
  profileUnavailable?: boolean;
  hasDisplayName?: boolean;
}): boolean {
  if (!opts.userDocReady) return false;
  if (opts.displayNameOnboardingDone === true || opts.cachedDone) return false;
  if (opts.profileUnavailable && opts.hasDisplayName) return false;
  return true;
}
